export const RTF_CONFIGURATION_MANAGEMENT_DATA_FETCH = 'RTF_CONFIGURATION_MANAGEMENT_DATA_FETCH'
export const RTF_CONFIGURATION_MANAGEMENT_FILE_DOWNLOAD = 'RTF_CONFIGURATION_MANAGEMENT_FILE_DOWNLOAD'
export const RTF_CONFIGURATION_MANAGEMENT_FILE_UPLOAD = 'RTF_CONFIGURATION_MANAGEMENT_FILE_UPLOAD'
export const RTF_CONFIGURATION_MANAGEMENT_FILE_DELETE = 'RTF_CONFIGURATION_MANAGEMENT_FILE_DELETE'

export type GetConfigManagementDataFunction = () => Promise<void>
export type ClearConfigManagementDataFunction = () => void
export type DownloadConfigManagementFileFunction = (file: File) => void

export type RTFConfigurationManagementState = {
  files: Array<File> 
}

export enum RTFConfigurationManagementActions {
  setFiles = 'setFiles',
  clearConfigManagementState = 'clearConfigManagementState',
}

export type RTFConfigurationManagementAction = {
  type: RTFConfigurationManagementActions.setFiles
  payload: Array<File>
} | {
  type: RTFConfigurationManagementActions.clearConfigManagementState
}

export type File = {
  fileName: string
  isBase: boolean
}

export type ConfigurationFilesResponse = {
  baseConfigurations: Array<string>
  customConfigurations: Array<string>
}

export type AxiosConfigurationFilesResponse = {
  data: ConfigurationFilesResponse
}
